<div class="content-dashboard">
  <div class="content-block-dashboard" *ngIf="isDashboard; else elseBlock">
    <abc-dashboard class="abc-dasboard-style" [endPoint]="dashboardEndpoint" [ajaxHeaders]="dashboardAjaxHeader" [initialDashboardId]="dashboardId">
    </abc-dashboard>
  </div>
  <ng-template #elseBlock>
    <h2 fxLayout="row" fxLayoutAlign="center end">{{ title }}</h2>
  </ng-template>
</div>
